import { DsGroup } from './ds-group';

export class DsUserProject {
  /**
   *
   */
  public g_id: number | null = null;

  /**
   *
   */
  public g_desc: string | null = '';

  /**
   *
   */
  public groups: DsGroup[] = [];

  /**
   * Creates an instance of DsUserProject.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    this.g_id = jsonData.g_id || this.g_id;
    this.g_desc = jsonData.g_desc || this.g_desc;
    // TODO:  Set up the correct type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.groups = jsonData.groups ? jsonData.groups.map((jsonObject: any) => new DsGroup(jsonObject)) : this.groups;
  }
}
